import { useDocumentRevisionParagraphs } from "~/stores/useDocumentRevisionParagraphs";

export const useDocumentRevisionParagraphsStore = (documentId: string) => {
  const { revision } = useSubmittedDocumentStore(documentId);

  if (!revision) {
    throw new Error("Revision is not defined");
  }

  return useDocumentRevisionParagraphs(documentId, revision.id)();
};
